﻿import { version } from '../../package.json';

export const current_intime_version = version;
export const apiBase: string = "/InTimeApi";
export const notifications_session_storage_key = "client_website_warnings";

export const dashboard_pages = {
    home: "/d",
    customers: "/d/customers",
    projects: "/d/projects",
    report: "/d/reports",
    profile: "/d/profile",
    settings: "/d/settings",
    customer_websites: "/d/customer-websites",
    reminders: "/d/reminders"
}

export const max_times_exception_count_warning: number = 5;
export const max_times_exception_count_severe: number = 10;
export const max_response_time_for_warning: number = 800;
export const max_response_time_for_severe: number = 1200;
export const max_response_time_times_warning: number = 5;
export const max_response_time_times_severe: number = 17;